import { authService, configService, initPlugins } from '@gc-bridge/services';
import { initEmbeddedRemotes, loadRemoteConfig, registerMfRemotes } from '@gcportal/base';

export async function setupApp() {
  if (window.location.pathname === '/logout') {
    return;
  }

  const { config } = await configService.loadConfig();

  if (!config?.authentication) {
    throw new Error('Okta authentication configuration is missing.');
  }

  authService.initOktaAuth(config.authentication);
  authService.registerTokenInterceptor();

  const { redirectInProgress } = (await authService.loginWithRedirect()) ?? {};

  if (redirectInProgress) {
    return { redirectInProgress };
  }

  await loadRemoteConfig(config, (await authService.getProfile())?.groups);

  const embeddedRemotes = initEmbeddedRemotes();

  if (embeddedRemotes.length) {
    registerMfRemotes(embeddedRemotes);
  }

  // Register plugin remotes and resolve their slots once, so that later config
  // refreshes never hand the embedded remotes new component types
  initPlugins(config.remotes ?? []);
}
